import { render, staticRenderFns } from "./formDepartment.vue?vue&type=template&id=170b3b74&scoped=true"
import script from "./formDepartment.vue?vue&type=script&lang=js"
export * from "./formDepartment.vue?vue&type=script&lang=js"
import style0 from "./formDepartment.vue?vue&type=style&index=0&id=170b3b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170b3b74",
  null
  
)

export default component.exports